/** Staff of a business and changing one's password (docs/specs/staff.md, B-71). */
export const staff = {
    title: "Staff",
    description: "The people who work in this business, what they may do, and their access.",
    add: "Add staff",
    empty: "No one besides you yet. Add your cashiers and managers.",
    everywhere: "All locations",
    you: "You",
    disabled: "Access off",
    mustChange: "First password",
    posPin: "POS PIN set",
    noPosPin: "No POS PIN",
    actions: "Actions for {{name}}",
    disable: "Turn access off",
    enable: "Turn access on",
    resetPassword: "Reset password",
    addRole: "Add role",
    removeRole: "Remove {{role}}",
    disabledOk: "{{name}} can no longer sign in to this business.",
    enabledOk: "{{name}} can sign in again.",
    roleAdded: "Role added.",
    roleRemoved: "Role removed.",
    roleNames: {
        owner: "Owner",
        admin: "Admin",
        branch_manager: "Branch Manager",
        cashier: "Cashier",
        inventory_staff: "Inventory Staff",
        order_staff: "Order Staff",
        accountant: "Accountant",
    },
    form: {
        title: "Add staff",
        description: "They sign in with this mobile number or e-mail and the first password you give them, then choose their own.",
        name: "Name",
        phone: "Mobile number",
        email: "E-mail (optional if a mobile number is given)",
        password: "First password",
        passwordHint: "At least 8 characters. Give it to them in person; they change it at first sign-in.",
        generate: "Generate",
        copy: "Copy",
        copied: "Copied.",
        role: "Role",
        location: "Where",
        submit: "Add",
        cancel: "Cancel",
    },
    added: {
        title: "{{name}} is added",
        body: "Give them these details. At first sign-in they choose their own password.",
        signIn: "Sign in with",
        password: "First password",
        done: "Done",
    },
    invitations: {
        title: "Invitations waiting for an answer",
        offer: "This person already has a Sobthik account, so they decide themselves. Send an invitation: they join when they accept it, and keep their own password.",
        send: "Send invitation",
        sent: "Invitation sent to {{name}}.",
        expires: "Open until {{date}}",
        revoke: "Withdraw",
        revoked: "Invitation withdrawn.",
        page: {
            title: "You are invited",
            body: "{{invitedBy}} invites you to join {{business}} as {{role}}. Nothing changes until you accept, and you keep your own password.",
            accept: "Accept and join",
            decline: "No, thanks",
            accepted: "You joined {{business}}.",
            declined: "Invitation declined.",
            gone: "This invitation is not available",
            goneBody: "It may have expired or been withdrawn, or it is meant for another account. Check that you are signed in with the right one.",
            home: "Go to my dashboard",
        },
    },
    reset: {
        title: "Reset the password of {{name}}",
        body: "They are signed out everywhere and must choose a new password at their next sign-in.",
        submit: "Reset password",
        done: "Password reset. Give {{name}} the new first password.",
    },
    roleForm: {
        title: "Add a role for {{name}}",
        submit: "Add role",
    },
};
//# sourceMappingURL=staff.js.map